const state = {
  orders: [],
  ordersInMonth: [],
  settlementSummaryForMonth: null,
  dnrFinishPreview: null,
};
const mutations = {
  SET_DOD_ORDERS(state, orders) {
    state.orders = orders;
  },
  SET_ORDERS_IN_MONTH(state, orders) {
    state.ordersInMonth = orders;
  },
  SET_SETTLEMENT_SUMMARY_FOR_MONTH(state, summary) {
    state.settlementSummaryForMonth = summary;
  },
  SET_DNR_FINISH_PREVIEW(state, preview) {
    state.dnrFinishPreview = preview;
  },
};
const getters = {
  getDodOrders: (state) => state.orders,
  getDodOrdersInMonth: (state) => state.ordersInMonth,
  getSettlementSummaryForMonth: (state) => state.settlementSummaryForMonth,
  getDnrFinishPreview: (state) => state.dnrFinishPreview,
};

export default {
  state,
  mutations,
  getters,
};
